export interface GratitudeEntry {
  id: string
  content: string
  prompt: string
  timestamp: Date
  date: string
}

const STORAGE_KEY = 'gratitude_entries'

export const saveGratitudeEntry = (content: string, prompt: string): GratitudeEntry => {
  const now = new Date()
  const entry: GratitudeEntry = {
    id: crypto.randomUUID(),
    content: content.trim(),
    prompt,
    timestamp: now,
    date: now.toLocaleDateString('en-US', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    })
  }

  const existingEntries = getGratitudeEntries()
  const updatedEntries = [entry, ...existingEntries]
  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedEntries))
  return entry
}

export const getGratitudeEntries = (): GratitudeEntry[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) return []
    
    const entries = JSON.parse(stored)
    // Convert timestamp strings back to Date objects
    return entries.map((entry: any) => ({
      ...entry,
      timestamp: new Date(entry.timestamp)
    }))
  } catch (error) {
    console.error('Error loading gratitude entries:', error)
    return []
  }
}

export const deleteGratitudeEntry = (id: string): void => {
  const existingEntries = getGratitudeEntries()
  const updatedEntries = existingEntries.filter(entry => entry.id !== id)
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedEntries))
}

export const clearAllGratitudeEntries = (): void => {
  localStorage.removeItem(STORAGE_KEY)
}